<template>
  <main>
    <div class="wrapper">
      <router-view name="sidebar"></router-view>
      <div class="content-page pb-0">
        <div class="content">
          <router-view name="topbar"></router-view>
          <router-view></router-view>
        </div>
        <!-- <router-view name="footer"></router-view> -->
      </div>
    </div>
    <div class="rightbar-overlay"></div>
  </main>
</template>

<script>
export default {
  name: "App",
};
</script>